<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>학습 통계</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">통계관리</a>
        </li>
        <li class="breadcrumb-item active">학습통계</li>
      </ol>
    </div>
    <!-- 검색 -->
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <div class="form-group align-items-center row mr-3">
            <div class="col-auto">
              <label class="col-form-label">채널</label>
            </div>
            <div class="col-auto">
              <input type="checkbox" class="ml-3" v-model="UseYn.teacher" true-value="yes" false-value="no" >
              <label class="form-check-label ml-2">교사</label>
              <input type="checkbox" class="ml-3" v-model="UseYn.turtor" true-value="yes" false-value="no" >
              <label class="form-check-label ml-2">강사</label>
              <input type="checkbox" class="ml-3" v-model="UseYn.student" true-value="yes" false-value="no" >
              <label class="form-check-label ml-2">학생(온라인스터디룸)</label>
            </div>
          </div>
          <!-- 기간검색 -->
          <SchDateRange label="조회기간" :data="data" @search="search" @reset="reset" />
        </div>
        <div class="form-row align-items-center">
          <!-- 학교급 -->
          <LabelSelect label="학교급" :opt="schoolGradeOpts" :value="schoolGradeValue"
            v-on:changeItem="onchangeSchoolGrade" />
          <!-- 학년 -->
          <LabelSelect label="학년" :opt="schoolYearOpts" :value="schoolYearValue"
            v-on:changeItem="onchangeSchoolYear" />
          <!-- 과목 -->
          <LabelSelect label="과목" :opt="subjectOpts" :value="subjectValue"
            v-on:changeItem="onchangeSubject" />
          <!-- 수업유형 -->
          <LabelSelect label="수업유형" :opt="lectTypeOpts" :value="lectTypeValue"
            v-on:changeItem="onchangeLectType" />
          <!-- 학습상태 -->
          <LabelSelect label="학습상태" :opt="unitClsStatusOpts" :value="unitClsStatusValue"
            v-on:changeItem="onchangeUnitClsStatus" />

          <!-- 항목 검색 -->
          <b-button-group class="ml-4">
            <button @click="search()" class="btn btn-primary mb-2"><i class="fa fa-search"></i>Search</button>
            <button @click="reset()" class="btn btn-secondary mb-2">Clear</button>
          </b-button-group>
        </div>
      </div>
    </div>
    <!-- 검색 -->

    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">학습상태 순위</span>
        <div class="card-tool float-right" >
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="excelDownload()" >엑셀 다운로드</b-btn>
        </div>
        <ShowCounter label="Show" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td style="text-align:center" @click="dataAction.sort(search,'seq')">No<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'date')">일자<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'channel')">채널<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'school_category_nm')">학교급<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'school_year')">학년<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'subject_nm')">과목<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'lect_type_nm')">수업유형<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'unit_cls_status_nm')">학습상태<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'cnt')">건 수<em class="fa-2s mr-2 fas fa-sort"></em></td>
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center">
            <td colspan="9">No matching records</td>
          </tr>
          <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index"  >
            <td class="align-middle text-center">{{item.seq}}</td>
            <td class="align-middle text-center">{{item.date}}</td>
            <td class="align-middle text-center">{{item.channel}}</td>
            <td class="align-middle text-center">{{item.schoolCategoryNm}}</td>
            <td class="align-middle text-center">{{item.schoolYear}}</td>
            <td class="align-middle text-center">{{item.subjectNm}}</td>
            <td class="align-middle text-center">{{item.lectTypeNm}}</td>
            <td class="align-middle text-center">{{item.unitClsStatusNm}}</td>
            <td class="align-middle text-center">{{item.cnt}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- 목록 -->          
  </ContentWrapper>
</template>

<script>
import { onMounted, reactive, computed } from '@vue/composition-api';
import { dataObject } from "@/utils/Constants";
import { getLectStatusList, getLectStatusListExcelDownload } from "@/api/stats/TextbookAdoptApi";
import Pagenation from '@/components/Common/Pagenation';
import SchDateRange from '../../components/Common/SchDateRange';
import ShowCounter from '../../components/Common/ShowCounter';
import LabelSelect from '../../components/Common/LabelSelect';
import { TableActionClass } from '@/utils/TableActionClass';
import store from "@/store/index";

export default {
  components: {SchDateRange, ShowCounter, Pagenation, LabelSelect},

  setup() {
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject);

    let UseYn = reactive({
      teacher : 'yes',
      turtor: 'yes',
      student: 'yes',
    });
    // 학교급
    const schoolGradeOpts = computed(() =>store.state.StatFilter.schoolGradeOpts);
    const schoolGradeValue = computed(() =>store.state.StatFilter.schoolGradeValue);
    const onchangeSchoolGrade = (value) => { store.dispatch('StatFilter/onchangeSchoolGrade', value) }
    // 학년
    const schoolYearOpts = computed(() =>store.state.StatFilter.schoolYearOpts);
    const schoolYearValue = computed(() =>store.state.StatFilter.schoolYearValue);
    const onchangeSchoolYear = (value) => { store.dispatch('StatFilter/onchangeSchoolYear', value) }
    // 과목
    const subjectOpts = computed(() =>store.state.StatFilter.subjectOpts);
    const subjectValue = computed(() =>store.state.StatFilter.subjectValue);
    const onchangeSubject = (value) => { store.dispatch('StatFilter/onchangeSubject', value) }
    // 수업유형
    const lectTypeOpts = computed(() =>store.state.StatFilter.lectTypeOpts);
    const lectTypeValue = computed(() =>store.state.StatFilter.lectTypeValue);
    const onchangeLectType = (value) => { store.dispatch('StatFilter/onchangeLectType', value) }
    // 학습상태
    const unitClsStatusOpts = computed(() =>store.state.StatFilter.unitClsStatusOpts);
    const unitClsStatusValue = computed(() =>store.state.StatFilter.unitClsStatusValue);
    const onchangeUnitClsStatus = (value) => { store.dispatch('StatFilter/onchangeUnitClsStatus', value) }

    /////////////////
    const loadData = () => { store.dispatch('StatFilter/resetFilter') }

    const fileRemove = () =>{
      data.row.url = null;
    }

    onMounted(loadData);

    return{
      dataObject,
      _dataObject,
      data,
      UseYn,
      schoolGradeOpts,
      schoolGradeValue,
      schoolYearOpts,
      schoolYearValue,
      subjectOpts,
      subjectValue,
      lectTypeOpts,
      lectTypeValue,
      unitClsStatusOpts,
      unitClsStatusValue,
      fileRemove,
      onchangeSchoolGrade,
      onchangeSchoolYear,
      onchangeSubject,
      onchangeLectType,
      onchangeUnitClsStatus,
      ...methods(),
      dataAction: new TableActionClass(data),
    }
  }
}

function methods() {
  var context = {};
  context['getLectStatusList'] = getLectStatusList;

  async function search() {
    let useChannel = '';
    if (this.UseYn.teacher==='yes') useChannel += '105002;';
    if (this.UseYn.turtor==='yes') useChannel += '105003;';
    if (this.UseYn.student==='yes') useChannel += '105005;';
    
    this.data.params.scUseChannel = useChannel;
    this.data.params.scSchoolGradeCd = this.schoolGradeValue;
    this.data.params.scSchoolYear = this.schoolYearValue;
    this.data.params.scSubjectCd = this.subjectValue;
    this.data.params.scLectTypeCd = this.lectTypeValue;
    this.data.params.scUnitClsStatusCd = this.unitClsStatusValue;
    let _params = this.data.params;
    await this.dataAction.execute("getLectStatusList",context,_params);
    this.fileRemove();
  }
  async function reset() {
    this.data.params.mode = "list";
  }
  async function excelDownload() {
    let useChannel = '';
    if (this.UseYn.teacher==='yes') useChannel += '105002;';
    if (this.UseYn.turtor==='yes') useChannel += '105003;';
    if (this.UseYn.student==='yes') useChannel += '105005;';

    this.data.params.scUseChannel = useChannel;
    this.data.params.scSchoolGradeCd = this.schoolGradeValue;
    this.data.params.scSchoolYear = this.schoolYearValue;
    this.data.params.scSubjectCd = this.subjectValue;
    this.data.params.scLectTypeCd = this.lectTypeValue;
    this.data.params.scUnitClsStatusCd = this.unitClsStatusValue;
    let _params = this.data.params;
    await getLectStatusListExcelDownload(_params, '학습통계');
  }

  return {
    search,
    reset,
    excelDownload
  }
}
</script>
